import { getErrorMessage } from "../../../utils/apiError";
import { getEmployeeId } from "../../../utils/session";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";

const NOT_LINKED = "Your account is not linked to an employee record.";

// Loading / not-linked / error states for useMyProfile. Renders `children`
// with the record once it has loaded.
const ProfileQueryState = ({ query, children }) => {
  if (!getEmployeeId() || query.error?.response?.status === 403) {
    return <div className={cx(ui.alert, ui.alertGray)}>{NOT_LINKED}</div>;
  }
  if (query.isLoading) {
    return (
      <div className={cx(ui.card, ui.empty)}>
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Loading your profile…
      </div>
    );
  }
  if (query.isError) {
    return (
      <div className={cx(ui.alert, ui.alertDanger)}>
        {getErrorMessage(query.error, "Unable to load your profile.")}
      </div>
    );
  }
  return children(query.data);
};

export default ProfileQueryState;
